module.exports = __webpack_public_path__ + "img/k1.51330b29.png";